import { waiverContants } from '../../_constants';
import { waiverServices } from '../../_services';
import { alertActions, confirmPromptActions, notificationActions, userActions, } from '../index';

export const waiverActions = {
    createWaivedCharge,                    
    searchWayBillBooking,                     
    getListWaivedCharges,            
    getWaivedId,            
    updateWaivedStatus,              
    updateWaived,                  
    deleteRevision,                    

    resetWaiver,        
    
    getListWaivedChargesForEndorsed,
}
function resetWaiver() { return { type: waiverContants.RESET } }

function waiverFetching() { return { type: waiverContants.WAIVER_FETCHING } }
function waiverFetched() { return { type: waiverContants.WAIVER_FETCHED } }

function waiverSubmitting() { return { type: waiverContants.WAIVER_SUBMITTING } }
function waiverSubmitted() { return { type: waiverContants.WAIVER_SUBMITTED } }

function createWaivedCharge(payload) {
    return dispatch => {
        dispatch(waiverSubmitting());
        dispatch(userActions.notallowLeavePage());
        waiverServices.createWaivedCharge(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(waiverSubmitted());
                    dispatch(alertActions.success('Successfully Created Waiver.'));
                    window.location.href = `/waiver/draft`;
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(waiverSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}
function updateWaivedStatus(payload, link, notification) {
    return dispatch => {
        dispatch(waiverSubmitting());
        dispatch(userActions.notallowLeavePage());
        waiverServices.updateWaivedStatus(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    if (notification) {
                        if(Array.isArray(notification)){
                            notification.forEach(async (element) => {
                                await dispatch(notificationActions.CreateWaivedChargesLog(element));
                            });
                        }
                        else {
                            dispatch(notificationActions.CreateWaivedChargesLog(notification));
                        }
                    }
                    dispatch(waiverSubmitted());
                    dispatch(alertActions.success(success.message));
                    setTimeout(() => {
                        if (link) {
                            if (payload.status === 'For Approval') {
                                if (success.datApproved) {
                                    window.location.href = '/waiver/approved';
                                }
                                else {
                                    window.location.href = link;
                                }
                            }
                            else {
                                window.location.href = link;
                            }
                        }    
                    }, 1000);
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(waiverSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}
function updateWaived(payload, id) {
    return dispatch => {
        dispatch(waiverSubmitting());
        dispatch(userActions.notallowLeavePage());
        waiverServices.updateWaived(payload, id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(waiverSubmitted());
                    dispatch(alertActions.success('Successfully Updated Waiver.'));
                    window.location.href = `/waiver/draft`;
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(waiverSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}
function deleteRevision(payload, userId, status, skip, take) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        waiverServices.deleteRevision(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    // dispatch(getListWaivedCharges(userId, isApprover, status, skip, take));
                    dispatch(getListWaivedChargesForEndorsed(userId, status, skip, take));
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Waiver Deleted Successfully.'));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}
function searchWayBillBooking(bookingRef) {
    return dispatch => {
        dispatch(waiverFetching());
        waiverServices.searchWayBillBooking(bookingRef)
            .then(
                BWData => {
                    dispatch(waiverFetched());
                    if (BWData && BWData.length && !BWData.message) {
                        dispatch(success(BWData));
                    } else {
                        dispatch(success(null));
                        if(BWData.message){
                            dispatch(alertActions.warning(BWData.message));
                        }
                        else {
                            dispatch(alertActions.warning('No Additional Charges'));
                        }
                    }
                },
                error => {
                    dispatch(waiverFetched());
                    dispatch(success(null));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(BWData) { return { type: waiverContants.SEARCH_BOOKING_WAYBILL, BWData } }
}
function getListWaivedCharges(userId, isApprover, status, skip, take, search) {
    return dispatch => {
        dispatch(waiverFetching());
        dispatch(userActions.allowLeavePage());
        waiverServices.getListWaivedCharges(userId, isApprover, status, skip, take, search)
            .then(
                waiverList => {
                    dispatch(waiverFetched());
                    if (waiverList.length > 0) {
                        dispatch(success(waiverList));
                    } else {
                        dispatch(success([]));
                        dispatch(alertActions.warning('No more data to Load'));
                    }
                },
                error => {
                    dispatch(waiverFetched());
                    dispatch(success([]));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(waiverList) { return { type: waiverContants.GET_WAIVERED_LIST, waiverList } }
}
function getWaivedId(id) {
    return dispatch => {
        dispatch(waiverFetching());
        dispatch(userActions.allowLeavePage());
        waiverServices.getWaivedId(id)
            .then(
                waiverById => {
                    dispatch(waiverFetched());
                    dispatch(success(waiverById));
                },
                error => {
                    dispatch(waiverFetched());
                    dispatch(success(null));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(waiverById) { return { type: waiverContants.GET_WAIVER_BY_ID, waiverById } }
}
function getListWaivedChargesForEndorsed(userId, status, skip, take, search, isEndorser) {
    return dispatch => {
        dispatch(waiverFetching());
        dispatch(userActions.allowLeavePage());
        waiverServices.getListWaivedChargesForEndorsed(userId, status, skip, take, search, isEndorser)
            .then(
                waiverList => {
                    dispatch(waiverFetched());
                    if (waiverList.length > 0) {
                        dispatch(success(waiverList));
                    } else {
                        dispatch(success([]));
                        dispatch(alertActions.warning('No more data to Load'));
                    }
                },
                error => {
                    dispatch(waiverFetched());
                    dispatch(success([]));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(waiverList) { return { type: waiverContants.GET_WAIVERED_ENDORSER_LIST, waiverList } }
}